import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/authentication/login.service';

@Component({
  selector: 'app-sales-home',
  templateUrl: './sales-home.component.html',
  styleUrls: ['./sales-home.component.css']
})
export class SalesHomeComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) {}

	ngOnInit() {
		this.menu = [
			{name:'Info Archivos', desc:'Subir Archivos Info General', icon:'fas fa-cloud-upload-alt', url:'/sales-info-files', perm: 'ADMIN-SALES-INFO_FILES'},
            {name:'Agentes', desc:'Mantenimiento Agentes', icon:'fas fa-user-tie', url:'/sales-agents', perm: 'ADMIN-SALES-AGENTS'},
            {name:'Agente Backup', desc:'Mantenimiento Agente Backup', icon:'fas fa-user-tie', url:'/sales-agent-backup', perm: 'ADMIN-SALES-AGENTS'},
            {name:'Gestión Agentes', desc:'Reporte de gestión de agentes', icon:'fas fa-table', url:'/agent-management-report', perm: 'ADMIN-SALES-REPORTS-AGENT_MANAGEMENT'},
            {name:'Seguimiento de Pedidos', desc:'Reporte de Seguimiento de Pedidos', icon:'fas fa-table', url:'/order-followup-report', perm: 'ADMIN-SALES-REPORTS-ORDER_FOLLOW'},
            {name:'Reporte de Versiones', desc:'Reporte de Versiones', icon:'fas fa-table', url:'/version-report', perm: 'ADMIN-SALES-REPORTS-VERSION_AGENT'},
            {name:'Auditoria de Sincronizaciones', desc:'Auditoria de Sincronizaciones', icon:'fas fa-table', url:'/sync-audit-report', perm: 'ADMIN-SALES-REPORTS-SYNC_AUDIT'},
            {name:'Aprobadores de Pedidos', desc:'Mantenimiento Aprobadores de Pedidos', icon:'fas fa-clipboard-check', url:'/order-approvers', perm: 'ADMIN-SALES-ORDER_APPROVERS'},
            {name:'Materias', desc:'Mantenimiento de Materias', icon:'fas fa-graduation-cap', url:'/sales-subjects', perm: 'SALES-TOPIC-SUBJECT'},
            {name:'Notas Vendedores', desc:'Ingreso de notas de vendedores', icon:'fas fa-tasks', url:'/sales-grades', perm: 'SALES-TOPIC-SCORE'},
            /*{name:'Grupo de Materiales para margen de ganancia', desc:'Grupo de Materiales para margen de ganancia', icon:'fas fa-layer-group', url:'/sales-discounts-materialgroup', perm: 'ADMIN-SALES-INFO_FILES'},
            {name:'Marcas para margen de ganancia', desc:'Marcas para margen de ganancia', icon:'fas fa-tags', url:'/sales-discounts-brand', perm: 'ADMIN-SALES-INFO_FILES'},*/
            {name:'Grupos y Marcas para margen de ganancia', desc:'Grupos y Marcas para margen de ganancia', icon:'fas fa-tags', url:'/sales-discounts-groupbrand', perm: 'ADMIN-SALES-INFO_FILES'}
		]
		this.auth.getPermissions().then(x => {
            this.permissions = x;
            
        });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){
            return true;
        }
        else{
            return false;
        }
    }

}
